module.exports = __webpack_public_path__ + "assets/img/kv-cb3507ff.jpg";